import { OrderAction, OrderStatus } from 'global/Securities/types/transaction';
import { PostShareRequestBody, ShareOrderStatus, ShareOrderType } from 'typings/api/shareTradeShare';
import { SHARE_TRADE_PREVIEW } from 'features/edit-profile/constants';
import { formatNumber } from 'utils/number';
import { ShareTradeInfo } from 'typings/api/shareTradeChat';
import {
  orderActionRemap,
  orderStatusRemap,
} from '../constants/shareTradeOrder';

type TransactionData = Omit<
  PostShareRequestBody,
  'save_as_autoshare' | 'targets'
>;

export const getRemapOrderStatus = (status: OrderStatus): ShareOrderStatus =>
  orderStatusRemap[status] || ShareOrderStatus.Unspecified;

export const getRemapOrderAction = (action: OrderAction): ShareOrderType =>
  orderActionRemap[action] || ShareOrderType.Unspecified;

export const getPreviewData = (transactionData: TransactionData) => {
  const { symbol, status, type, price, total_investment, order_time } = transactionData || {};
  return {
    ...SHARE_TRADE_PREVIEW,
    symbol,
    status,
    order_time,
    order_type: type,
    text: `Order ${type === 'ORDER_TYPE_BUY' ? 'Buy' : 'Sell'} ${symbol}`,
    price: `Rp ${formatNumber(price)}`,
    total_investment: `Rp ${formatNumber(total_investment)}`,
  } as ShareTradeInfo;
};
